export default __webpack_public_path__ + "static/media/12-2.28433e14.jpg";